/* tslint:disable:no-var-requires */

import {Injectable} from '@angular/core';

const LocalForage = require('localforage');

import {DatabaseCollection} from './database-collection';

@Injectable()
export class DatabaseService {
  private _instances: any = {};

  constructor() {
    this._instances = {};
    LocalForage.config({
      driver:
          [LocalForage.WEBSQL, LocalForage.INDEXEDDB, LocalForage.LOCALSTORAGE],
      name: 'smartenit',
      version: 1.1
    });
  }

  public clear(excludedInstances?: string[]) {
    const instanceKeys = Object.keys(this._instances);

    for (let i = 0; i < instanceKeys.length; i++) {
      const key = instanceKeys[i];
      if (excludedInstances && excludedInstances.length > 0) {
        if (excludedInstances.indexOf(key) < 0) {
          this._instances[key].clear();
        }
      } else {
        this._instances[key].clear();
      }
    }
  }

  public getCollection(collectionName: string): DatabaseCollection {
    let instance: any;

    if (this._instances.hasOwnProperty(collectionName)) {
      return this._instances[collectionName];
    }

    if (!instance) {
      instance = new DatabaseCollection(collectionName);
      this._instances[collectionName] = instance;
    }

    return instance;
  }
}
